// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import ajax from '@/services/ajax'
import request from '@/services/request'
import INTERFACE from './interface'
import '@/style/all'
import './assets/common/css/theme/index.css'
import './assets/common/css/pages.css'
import '@/assets/font/css/font-awesome.css'
import config from './config'

window.localStorage.permissionCheckUrl = 'platform/v1/access/resources'
window.localStorage.defaultLanguage = 'ZH_CN'

// 动态设置环境
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {
  // dev环境
  window.localStorage.gatewayDomain = 'https://dev-api.zjlh.lan/'
  window.localStorage.serviceName = 'https://dev-bmp-policy.zjlh.lan'
  window.localStorage.loginUrl = 'https://dev-bmp.zjlh.lan'
  window.localStorage.dashboardUrl = 'https://dev-bmp.zjlh.lan/#/dashboard'
  window.localStorage.cookieDomain = '.zjlh.lan'
} else if (process.env.NODE_ENV === 'stag') {
  // stag预发布环境
  window.localStorage.gatewayDomain = 'https://stag-api.gc-life.cn/'
  window.localStorage.serviceName = 'https://stag-bmp-policy.gc-life.cn'
  window.localStorage.loginUrl = 'https://stag-bmp.gc-life.cn'
  window.localStorage.dashboardUrl = 'https://stag-bmp.gc-life.cn/#/dashboard'
  window.localStorage.cookieDomain = '.gc-life.cn'
} else if (process.env.NODE_ENV === 'production') {
  // 生产环境
  window.localStorage.gatewayDomain = 'https://api.gc-life.com/'
  window.localStorage.serviceName = 'https://bmp-policy.gc-life.com'
  window.localStorage.loginUrl = 'https://bmp.gc-life.com/#/'
  window.localStorage.dashboardUrl = 'https://bmp.gc-life.com/#/dashboard'
  window.localStorage.cookieDomain = '.gc-life.com'
}
console.log(window.localStorage.gatewayDomain)

// 插件配置
Vue.use(ElementUI)

config.init()

// axios 统一配置
ajax.init()

// 设置请求头
request.init()

// 此处调用国际化接口，获取国际化数据
var language = config.getCookie('language')
if (!language || !language.length) {
  language = window.localStorage.defaultLanguage
}
INTERFACE.getI18n(language).then(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App},
    data: {
      eventBus: new Vue()
    }
  })
})



// WEBPACK FOOTER //
// ./src/main.js